import { listConstants } from "../constants";
import { reorderArray } from "../utils/reorderArray";
import { sortList } from "../actions/list.actions";
import { sortListItem } from "../actions";

export const handleDragEndList = async ({ 
    result, 
    lists, 
    dispatch, 
    content_group_id, 
    workspace_id 
}) => {
    const { source, destination, type } = result;
    if (!destination || source.index === destination.index) return;

    if (type === "LIST"){
        // Reorder items locally for the API call
        const updatedLists = reorderArray(lists, source.index, destination.index);
        
        // Update Redux here
        dispatch({
            type: listConstants.LIST_SET,
            payload: {
                data: {
                    data: {
                        lists: updatedLists,
                    }
                }
            }
        });

        // API call to update the order of lists
        const updatedListIds = updatedLists.map((l, index) => ({id: l.id }));

        dispatch(sortList({workspace_id, content_group_id, sorted_list_ids: updatedListIds}));

    } else if (type === "ITEM") {
        if (source.droppableId !== destination.droppableId) return;

        // Reorder items within a specific list
        const listId = source.droppableId.split('-')[1]; // Extracting list ID from droppableId
        const updatedList = lists.find(l => l.id === parseInt(listId));
        
        if (updatedList) {
            const updatedItems = reorderArray(updatedList.items, source.index, destination.index);
            const updatedListWithItems = { ...updatedList, items: updatedItems };

            // Update Redux here
            dispatch({
                type: listConstants.LIST_UPDATED,
                payload: {
                    data: {
                        data: updatedListWithItems,
                    }
                }
            });
            // API call to update the order of items in the list
            dispatch(sortListItem({
                workspace_id,
                content_group_id,
                list_id: updatedList.id,
                sorted_list_item_ids: updatedItems
            }))
        }
    }

    // Submit API call to update the order
};